import { signalStoreFeature, withComputed, withProps } from '@ngrx/signals';
import { IWorkItemsStore } from './workitems.public';

export function withWorkItems(workItemsStore: IWorkItemsStore) {
    return signalStoreFeature(
        withComputed(() => ({
            workItems: workItemsStore.workItems,
            systemWorkItems: workItemsStore.systemWorkItems,
            activeWorkItem: workItemsStore.activeWorkItem,
            activeConversation: workItemsStore.activeConversation,
            activeMonitoredTask: workItemsStore.activeMonitoredTask,
            activeMonitoredTasks: workItemsStore.activeMonitoredTasks,
            hasActiveMonitoredTasks: workItemsStore.hasActiveMonitoredTasks,
        })),
        withProps(() => ({
            onWorkItemAdded$: workItemsStore.onWorkItemAdded$,
            onWorkItemRemoved$: workItemsStore.onWorkItemRemoved$,
            onWorkItemStateChanged$: workItemsStore.onWorkItemStateChanged$,
            onWorkItemCustomerChanged$:
                workItemsStore.onWorkItemCustomerChanged$,
        })),
    );
}
